export class ImportFileLuongBoSungRequest {
    "file": FormData;
    "idNhomNhanSu": number;
    "namQuyetToan": number
};

export class LuongBoSungResponse {
    "hoTen": string;
    "tenChucVu": string;
    "idNhanVien": number;
    "maNhanVien": string;
    "ngayCongHuongLuong": number;
    "heSoNgayCong": number;
    "mucLuongCB": number;
    "mucLuongCBCaNam": number;
    "tongLuongDuocNhan": number;
    "tongLuongDaNhan": number;
    "soTienConDuocNhan": number;
};

export class LuongBoSungNLDResponse {
    "idNhanVien": number;
    "hoTen": string;
    "maNhanVien": string;
    "tenChucVu": string;
    "luongCBThangDau": number;
    "luongCBThangGiua": number;
    "luongCBThangCuoi": number;
    "luongQuyMot": number;
    "luongQuyHai": number;
    "luongQuyBa": number;
    "luongQuyBon": number;
    "tongLuongCB": number;
    "soTienConDuocNhan": number;
    "tongLuongDaNhan": number;
    "tongLuongDuocNhan": number;
    "ngayCongHuongLuong": number;
    "heSoNgayCong": number;
    "luongTTDuocNhanThangDau": number;
    "luongTTDuocNhanThangGiua": number;
    "luongTTDuocNhanThangCuoi": number;
    "tongCong": number;
}

export class DieuChinhLuongBoSungNLDResponse {
    "idNhanVien": number;
    "hoTen": string;
    "maNhanVien": string;
    "tenChucVu": string;
    "luongCBThangDau": number;
    "luongTTDuocNhanThangDau": number;
    "luongCBThangGiua": number;
    "luongTTDuocNhanThangGiua": number;
    "luongCBThangCuoi": number;
    "luongTTDuocNhanThangCuoi": number;
    "tongLuongCB": number;
    "soTienConDuocNhan": number;
    "tongLuongDaNhan": number;
    "tongLuongDuocNhan": number;
    "ngayCongHuongLuong": number;
    "heSoNgayCong": number;
}

export class DanhSachLuongBoSungResponse {
    "id": number;
    "soNhanVien": number;
    "tongSoTienConDuocNhan": number;
    "ten": string;
    "tenQTDieuChinh": string;
    "isQuanLy": boolean;
    "coTheDieuChinh": boolean;
    "thoiGian": string
};

export class ChiTietLuongBoSungResponse {
    "id": number;
    "loai": number;
    "quy": number;
    "nam": number;
    "trangThai": number;
    "thangQuyetToan": Date;
    "isThangTamTinh": boolean;
    "loaiBoSung": number;
    "coTheDieuChinh": boolean;
    "idLuongQuyetToanDieuChinh": number | null;
    "ten": string;
    "dsLuongBoSung": Array<LuongBoSungNLDResponse>;
    "tongLuongDuocNhan": number;
    "tongLuongThangDau": number;
    "tongLuongThangGiua": number;
    "tongLuongThangCuoi": number;
}